module.exports = __webpack_public_path__ + "img/next.81050c50.svg";